import { ActiveElement, ChartEvent, ScatterDataPoint } from "chart.js"
import { ReactNode, useCallback } from "react"
import { ChartCard, ChartCardProps } from "../components/Card"
import { BarChartComponent, BarChartProps } from "./BarChartComponent"

type Props<TData, TLabel> = {
  chart: BarChartProps<TData, TLabel>
  card?: ChartCardProps
  dataTestId?: string
  onChartClick?: (event: ChartEvent, chartElement: ActiveElement[]) => void
}

export const BarChart = <TData = (number | ScatterDataPoint | null)[], TLabel = unknown>({
  chart,
  card,
  dataTestId,
  onChartClick,
}: Props<TData, TLabel>) => {
  const Wrap = useCallback(
    // eslint-disable-next-line react/no-unused-prop-types
    ({ children }: { children: ReactNode }) =>
      card ? (
        <ChartCard dataTestId={dataTestId} {...card}>
          {children}
        </ChartCard>
      ) : (
        <div data-testid={dataTestId}>{children}</div>
      ),
    [card, dataTestId]
  )
  return (
    <Wrap>
      <BarChartComponent<TData, TLabel> {...{ ...chart }} onChartClick={onChartClick} />
    </Wrap>
  )
}

BarChart.defaultProps = {
  card: undefined,
  dataTestId: undefined,
  onChartClick: undefined,
}
